module.exports = __webpack_public_path__ + "static/media/coins_collect.c920e6f1.mp3";